import { Button, Menu, MenuItem } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

interface HeaderMenuEntryProps {  
  title: string;
  href?: string;
  children?: { title: string; href: string }[];
}

const HeaderMenuButton: React.FC<HeaderMenuEntryProps> = ({ title, href, children }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  if (children) {
    return <>
      <Button
        onClick={handleClick}
        sx={{ my: 2, color: 'white', display: 'block' }}
      >
        {title}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{paper: { sx: { background: '#333', color: 'white' } }}}
      >
        {children.map((entry) => (
        <MenuItem
          key={entry.title}
          component={Link}
          to={entry.href!}
          onClick={handleClose}
        >
          {entry.title}
        </MenuItem>
        ))}
      </Menu>
    </>;
  } else {
    return (
      <Button
        component={Link}
        to={href!}
        sx={{ my: 2, color: 'white', display: 'block' }}
      >
        {title}
      </Button>
    );
  }
};

export default HeaderMenuButton;
